import React, {useEffect, useState} from "react";
import Modal from "../modal/modal";
import axiosInstance from "../../AxiosInstance";
import styles from "./explorer.module.css";

export default function Explorer({show, setter, handleActionData, actionData}) {
    const project_id = parseInt(localStorage.getItem('project_id'));
    const [step, setStep] = useState(0);

    const [deviceUsers, setDeviceUsers] = useState([]);
    const [devices, setDevices] = useState([]);
    const [variables, setVariables] = useState([]);

    const [selectedDeviceUser, setSelectedDeviceUser] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [selectedVariable, setSelectedVariable] = useState(null);

    useEffect(() => {
        let isMounted = true;
        if (!project_id) return;
        axiosInstance.get(`device_user/?project_id=${project_id}`).then((response) => {
            if (isMounted) {
                setDeviceUsers(response.data);
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        let isMounted = true;
        setDevices([]);
        if (!selectedDeviceUser?.id) return;
        axiosInstance.get(`device/?machine=${selectedDeviceUser?.id}`).then((response) => {
            if (isMounted) {
                setDevices(response.data);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [selectedDeviceUser]);

    useEffect(() => {
        setVariables([]);
        setVariables(selectedDevice?.variables);
    }, [selectedDevice]);

    useEffect(() => {
        setStep(0);
    }, [show]);

    return (
        <Modal show={show} setter={setter} name={'Select Variable'}>
            <div>
                <div className={styles.backButton} onClick={() => {
                    if(step === 0) {
                        setter(false);
                    } else {
                        setStep(step - 1);
                    }
                }}>{'< Back'}</div>
                <div style={{
                    maxHeight: '300px',
                    overflowY: "scroll"
                }}>
                    {(step === 0?
                        deviceUsers?.map((deviceUser, index) => {
                            return (
                                <div key={index} className={styles.folder} onClick={() => {
                                    setSelectedDeviceUser(deviceUser);
                                    setStep(1);
                                }}>
                                    <div>
                                        <div className={'py-2 px-2'}>{deviceUser.name}</div>
                                    </div>
                                    <div className={styles.folderSelector}>{'>'}</div>
                                </div>
                            );
                        })
                        : step === 1 ?
                            devices?.map((device, index) => {
                                return (
                                    <div key={index} className={styles.folder} onClick={() => {
                                        setStep(2);
                                        setSelectedDevice(device);
                                    }}>
                                        <div>
                                            <div className={'py-2 px-2'}>{device.name}</div>
                                        </div>
                                        <div className={styles.folderSelector}>{'>'}</div>
                                    </div>
                                );
                            })
                                :
                                variables?.map((variable, index) => {
                                    return (
                                        <div key={index} className={styles.folder} onClick={() => {
                                            const newData = {target: {value: "<specialTag>YOUR_VALUE</specialTag>"}};
                                            handleActionData(newData, 1);
                                            setter(false);
                                        }}>
                                            <div>
                                                <div className={'py-2 px-2'}>{variable?.variable?.name}</div>
                                            </div>
                                            <div className={styles.folderSelector}>{'>'}</div>
                                        </div>
                                    );
                                })
                        )
                    }
                </div>
            </div>
        </Modal>
    );
}